import React from 'react';

const DownloadApp = props => {
    const { dataLocale: { DOWNLOAD_LENSKART_APP_BUY, DOWNLOADAPP_PRODUCTTYPE, CONTACT_LENS, SUNGLASSES, EYEGLASSES } } = props;
    let productType = DOWNLOADAPP_PRODUCTTYPE;
    if (props.location.pathname.indexOf('sunglass') !== -1) productType = SUNGLASSES;
    else if (props.location.pathname.indexOf('eyeglass') !== -1) productType = EYEGLASSES;
    else if (props.location.pathname.indexOf('contact') !== -1 || props.location.pathname.indexOf('lens') !== -1) productType = CONTACT_LENS;
    return (
        <div className="container-fluid">
            <div className="margin-b20 col-sm-12 text-center downloadApp fs16 fw700">
                <span>{DOWNLOAD_LENSKART_APP_BUY} <a href="https://www.lenskart.com/mobile-app" className="color-green">{`${productType}.`}</a></span>
            </div>
        </div>
    );
};

export default DownloadApp;
